var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpcomingInterviews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.659,
    height: 18.317,
    viewBox: "0 0 23.659 18.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7384",
    "data-name": "Path 7384",
    d: "M24.169,9.736H12.962V8.49H24.169Zm0,1.245H12.962v1.245H24.169ZM26.659,6v8.717h-2.49v4.62l-4.62-4.62h-.361V19.7H10.11l-4.62,4.62V19.7H3V10.981h7.471V6Zm-8.717,8.717H10.471v-2.49H4.245v6.226h2.49V21.3l2.852-2.852h8.355Zm7.471-7.471h-13.7v6.226h8.355l2.852,2.852V13.471h2.49ZM9.226,13.471H5.49v1.245H9.226ZM5.49,17.207H16.7V15.962H5.49Z",
    transform: "translate(-3 -6)",
    fill: "#c5c9f6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingInterviews);
export default __webpack_public_path__ + "static/media/upcoming-interviews.b7831795584cbbf67e846ce88e7eb353.svg";
export { ForwardRef as ReactComponent };